export default {
  state: {
    default: {},
  },

  getters: {
    getStoppingData(state) {
      return state.default;
    },
  },

  mutations: {
    setStoppingData(state, data) {
      const isNull = data === null;

      state.default = {
        id: !isNull ? data.id : "",
        route_id: !isNull ? Number(data.route_id) : "",
        county_id: !isNull ? Number(data.county_id) : "",
        stopping_point: !isNull ? data.stopping_point : "",
      };
    },
  },

  actions: {
    changeStoppingData(context, infos) {
      context.commit("setStoppingData", infos);
    },
  },
};
